import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';
import { IconTick1 } from '@99designs/icons';

export type FeaturesListProps = {
    features: React.ReactNode[];
    isSplit?: boolean;
    iconColor?: string;
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;

    ${mediaQuery.only('small')} {
        flex-direction: column;
        row-gap: ${spaces['0.75bu']};
    }
`;

const List = styled.ul`
    list-style-type: none;
    display: flex;
    flex: 1;
    flex-direction: column;
    word-break: break-word;
    row-gap: ${spaces['0.5bu']};
    margin-bottom: 0;
    margin-left: 0;
    padding-left: 0;
`;

const ListItem = styled.li`
    padding-left: 21px;
    padding-right: ${spaces['1.5bu']};
    width: 100%;
`;

const IconWrapper = styled.div`
    position: absolute;
    margin-left: -21px;
`;

const FeatureList = ({ features, iconColor = 'inherit' }: FeaturesListProps) => (
    <List>
        {features.map((feature, i) => {
            return (
                <ListItem key={i}>
                    <IconWrapper>
                        <IconTick1
                            offsetRight={true}
                            color={iconColor}
                            aria-label={__('available')}
                        />
                    </IconWrapper>
                    <Box paddingLeft="1bu">{feature}</Box>
                </ListItem>
            );
        })}
    </List>
);

export function FeaturesList({ features, isSplit = false, iconColor }: FeaturesListProps) {
    if (isSplit) {
        const middleIndex: number = Math.ceil(features.length / 2);
        const featuresFirstHalf: React.ReactNode[] = features.slice(0, middleIndex);
        const featuresSecondHalf: React.ReactNode[] = features.slice(middleIndex);

        return (
            <Container>
                <FeatureList features={featuresFirstHalf} iconColor={iconColor} />
                <FeatureList features={featuresSecondHalf} iconColor={iconColor} />
            </Container>
        );
    }

    return (
        <Container>
            <FeatureList features={features} iconColor={iconColor} />
        </Container>
    );
}
